export enum DeliveryCode {
    Standard,
    Overnight,
    WillCall,
    TwoDay,
    StandardOvernight,
    FirstClass,
    USPSPriority,
    Delivery
}